import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "./common/Card";
import Grid from "@material-ui/core/Grid";
import Typography from "./common/Typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import crioLogo from "../../src/assets/crio-logo-white.svg";
import axios from "axios";
import Loader from "./common/Loader/Loader";
import ReactHtmlParser from "react-html-parser";
import myJson from "../data/data.json";

const styles = (theme) => ({
  top: {
    borderBottom: "1px solid" + theme.palette.primary.primaryBorder,
    padding: "0px 55px",
  },
  middle: {
    margin: "45px 55px",
  },
  subtitle: {
    display: "flex",
    alignItems: "center",
  },
  socialIcon: {
    color: theme.palette.primary.primary,
    fontSize: "32px",
    marginLeft: "20px",
  },
  arrowIcon: {
    color: theme.palette.primary.primary,
    marginLeft: "5px",
    cursor: "pointer",
  },
  programs: {
    margin: "35px 0px 30px 0px",
    color: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    alignItems: "center",
  },

  programRow: { padding: "10px 0px 0px 0px" },
  MERow: {
    margin: "55px 0px 0px 0px",
    // borderBottom: "1px solid" + theme.palette.primary.primaryBorder
  },
  programPill: {
    display: "flex",
    alignItems: "center",
    background: "#3f3f3f",
    width: "fit-content",
    padding: "16px",
    borderRadius: "8px",
    margin: "10px 0px",
  },
});

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      meDetail: {},
      user: "",
      isLoading: true,
      qbox: {},
      qmoney: "",
      qcharm: "",
      qprep: "",
    };
    this.title = this.title.bind(this);
  }

  title(str) {
    return str
      .split(" ")
      .map((s) => s.slice(0, 1).toUpperCase() + s.slice(1).toLowerCase())
      .join(" ");
  }

  render() {
    const { classes } = this.props;
    return (
      <Grid container>
        <Grid row lg={2} md={1} xs={1}></Grid>
        <Grid row lg={7} md={10} xs={10}>
          <Card>
            <div className={classes.top}>
              <Typography fontSize="48px">
                {process.env.REACT_APP_FULL_NAME}
              </Typography>
              <div className={classes.subtitle}>
                <Typography fontSize="34px" color="rgba(0,0,0,0.6)">
                  Backend Developer
                </Typography>
                <a
                  href={process.env.REACT_APP_LINKEDIN}
                  target="_blank"
                  rel="noopener"
                >
                  <FontAwesomeIcon
                    icon={["fab", "linkedin"]}
                    className={classes.socialIcon}
                  ></FontAwesomeIcon>
                </a>
                <a
                  href={process.env.REACT_APP_GITHUBURL}
                  target="_blank"
                  rel="noopener"
                >
                  <FontAwesomeIcon
                    icon={["fab", "github"]}
                    className={classes.socialIcon}
                  ></FontAwesomeIcon>
                </a>
              </div>
              <div className={classes.programs}>
                <Grid container>
                  <Grid item lg={1} md={1} xs={12}>
                    <Typography type="body2" color="rgba(0,0,0,0.6)">
                      Programs:
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    lg={5}
                    md={5}
                    xs={12}
                    style={{ marginLeft: "40px" }}
                  >
                    <Typography type="body2" color="#7C8DFF">
                      Crio Launch
                    </Typography>
                  </Grid>
                </Grid>
              </div>
              <a
                href={`${process.env.REACT_APP_CERTIFICATE_URL}`}
                target="_blank"
              >
                <div
                  className="viewCertificate"
                  style={{
                    padding: "10px",
                    border: "1px solid #7C8DFF",
                    width: "max-content",
                    borderRadius: "4px",
                    margin: "0px 0px 60px 0px",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                >
                  <FontAwesomeIcon
                    icon={["fas", "file-alt"]}
                    style={{ marginRight: "10px" }}
                    className={classes.arrowIcon}
                  ></FontAwesomeIcon>
                  <Typography type="body2" color="#7C8DFF" cursor="pointer">
                    VIEW CERTIFICATE
                  </Typography>
                </div>
              </a>
            </div>
            <div className={classes.middle}>
              <Typography type="body1" color="rgba(0,0,0,0.6)">
                Crio Experience
              </Typography>
              <div className={classes.programRow}>
                <div className={classes.programPill}>
                  <img
                    alt="Crio.Do"
                    src={crioLogo}
                    style={{ marginRight: "10px" }}
                  ></img>
                  <Typography type="heading3" color="rgba(255,255,255,1)">
                    Crio Launch
                  </Typography>
                </div>
                <Typography type="body5" color="rgba(0,0,0,0.6)">
                  31 Jan 2020 - 10 Apr 2020
                </Typography>
              </div>
              <ul className="timeline">
                {myJson.qbox_outer && myJson.qbox_outer.cardContentContainer ? (
                  <>
                    <li>
                      <div className={classes.MERow} class="meRow">
                        <Grid container>
                          <Grid item xs={12}>
                            <Typography type="heading3" color="rgba(0,0,0,1)">
                              QBox
                            </Typography>
                            <div style={{ marginTop: "16px" }}>
                              <Typography type="body5" color="rgba(0,0,0,1)">
                                {" "}
                                {ReactHtmlParser(
                                  myJson.qbox_outer.cardContentContainer
                                    .cardContentList[1].cardBody
                                )}{" "}
                              </Typography>
                              <div style={{ marginTop: "25px" }}>
                                <Grid item xs={12} md={2}>
                                  <Typography
                                    type="body5"
                                    color="rgba(0,0,0,0.6)"
                                  >
                                    Skills Learned:
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} md={10}>
                                  <Typography
                                    type="body5"
                                    color="rgba(0,0,0,1)"
                                  >
                                    {ReactHtmlParser(myJson.qbox_outer.skills)}{" "}
                                  </Typography>
                                </Grid>
                              </div>
                              <div style={{ margin: "30px 0px" }}>
                                <Grid container>
                                  <Grid item xs={4}>
                                    <Link
                                      to={{
                                        pathname: "/detail/ME_QBOX",
                                        aboutProps: {
                                          data: this.state.meDetail["ME_QBOX"],
                                          getTitle: this.props.getTitle,
                                        },
                                      }}
                                    >
                                      <Typography
                                        type="body5"
                                        color="#7C8DFF"
                                        cursor="pointer"
                                      >
                                        VIEW DETAILS
                                        <FontAwesomeIcon
                                          icon={["fas", "arrow-right"]}
                                          className={classes.arrowIcon}
                                        ></FontAwesomeIcon>
                                      </Typography>
                                    </Link>
                                  </Grid>
                                </Grid>
                              </div>
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                    </li>
                    <div
                      style={{
                        marginLeft: "80px",
                        borderBottom: "1px solid #d8d8d8",
                        marginBottom: "30px",
                      }}
                    ></div>
                  </>
                ) : (
                  ""
                )}
                <li>
                  <div className={classes.MERow} class="meRow">
                    <Grid container>
                      <Grid item xs={12}>
                        <Typography type="heading3" color="rgba(0,0,0,1)">
                          QMoney
                        </Typography>
                        <div style={{ marginTop: "16px" }}>
                          <Typography type="body5" color="rgba(0,0,0,1)">
                            {ReactHtmlParser(
                              myJson.qmoney_outer.cardContentContainer
                                .cardContentList[1].cardBody
                            )}{" "}
                          </Typography>
                          <div style={{ marginTop: "25px" }}>
                            <Grid item xs={12} md={2}>
                              <Typography type="body5" color="rgba(0,0,0,0.6)">
                                Skills Learned:
                              </Typography>
                            </Grid>
                            <Grid item xs={12} md={10}>
                              <Typography type="body5" color="rgba(0,0,0,1)">
                                {ReactHtmlParser(myJson.qmoney_outer.skills)}{" "}
                              </Typography>
                            </Grid>
                          </div>
                          <div style={{ margin: "40px 0px" }}>
                            <Grid container>
                              <Grid item xs={4}>
                                <Link
                                  to={{
                                    pathname: "/detail/ME_QMONEY",
                                    aboutProps: {
                                      data: this.state.meDetail["ME_QMONEY"],
                                      getTitle: this.props.getTitle,
                                    },
                                  }}
                                >
                                  <Typography
                                    type="body5"
                                    color="#7C8DFF"
                                    cursor="pointer"
                                  >
                                    VIEW DETAILS
                                    <FontAwesomeIcon
                                      icon={["fas", "arrow-right"]}
                                      className={classes.arrowIcon}
                                    ></FontAwesomeIcon>
                                  </Typography>
                                </Link>
                              </Grid>
                            </Grid>
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </li>
                <div
                  style={{
                    marginLeft: "80px",
                    borderBottom: "1px solid #d8d8d8",
                    marginBottom: "30px",
                  }}
                ></div>{" "}
                <li>
                  <div className={classes.MERow} class="meRow">
                    <Grid container>
                      <Grid item xs={12}>
                        <Typography type="heading3" color="rgba(0,0,0,1)">
                          QPrep
                        </Typography>
                        <div style={{ marginTop: "16px" }}>
                          <Typography type="body5" color="rgba(0,0,0,1)">
                            {ReactHtmlParser(
                              myJson.qprep_outer.cardContentContainer
                                .cardContentList[1].cardBody
                            )}{" "}
                          </Typography>
                          <div style={{ marginTop: "25px" }}>
                            <Grid item xs={12} md={2}>
                              <Typography type="body5" color="rgba(0,0,0,0.6)">
                                Skills Learned:
                              </Typography>
                            </Grid>
                            <Grid item xs={12} md={10}>
                              <Typography type="body5" color="rgba(0,0,0,1)">
                                Applied DSA
                              </Typography>
                              <br></br>
                            </Grid>
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </li>
                {myJson.qcharm_outer && myJson.qcharm_inner ? (
                  <>
                    <div
                      style={{
                        marginLeft: "80px",
                        borderBottom: "1px solid #d8d8d8",
                        marginBottom: "30px",
                      }}
                    ></div>
                    <li>
                      <div className={classes.MERow} class="meRow">
                        <Grid container>
                          <Grid item xs={12}>
                            <Typography type="heading3" color="rgba(0,0,0,1)">
                              QCharm
                            </Typography>
                            <div style={{ marginTop: "16px" }}>
                              <Typography type="body5" color="rgba(0,0,0,1)">
                                {ReactHtmlParser(
                                  myJson.qcharm_outer.cardContentContainer
                                    .cardContentList[1].cardBody
                                )}{" "}
                              </Typography>
                              <div style={{ marginTop: "25px" }}>
                                <Grid item xs={12} md={2}>
                                  <Typography
                                    type="body5"
                                    color="rgba(0,0,0,0.6)"
                                  >
                                    Skills Learned:
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} md={10}>
                                  <Typography
                                    type="body5"
                                    color="rgba(0,0,0,1)"
                                  >
                                    {ReactHtmlParser(
                                      myJson.qcharm_outer.skills
                                    )}{" "}
                                  </Typography>
                                </Grid>
                              </div>
                            </div>
                          </Grid>
                        </Grid>
                      </div>{" "}
                      <div style={{ margin: "30px 0px" }}>
                        <Grid container>
                          <Grid item xs={4}>
                            <Link
                              to={{
                                pathname: "/detail/ME_QCHARM",
                                aboutProps: {
                                  data: this.state.meDetail["ME_QCHARM"],
                                  getTitle: this.props.getTitle,
                                },
                              }}
                            >
                              <Typography
                                type="body5"
                                color="#7C8DFF"
                                cursor="pointer"
                              >
                                VIEW DETAILS
                                <FontAwesomeIcon
                                  icon={["fas", "arrow-right"]}
                                  className={classes.arrowIcon}
                                ></FontAwesomeIcon>
                              </Typography>
                            </Link>
                          </Grid>
                        </Grid>
                      </div>
                    </li>
                  </>
                ) : (
                  ""
                )}
              </ul>
            </div>
          </Card>
        </Grid>
        <Grid row lg={2} md={1} xs={1}></Grid>
      </Grid>
    );
  }
}
export default withStyles(styles)(Home);
